import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import constants from 'Constants';
import * as utils from 'Utils';
import './styles.scss';



@observer
class SubMenuItem extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const { subMenu } = this.props;
    if (!subMenu.display) return null;
    return (
      <a
        href={subMenu.href}
        onClick={subMenu.onClick}
        className={subMenu.isActive ? "submenu-link active-link": "submenu-link"}
      >
        <span className="submenu-label">{subMenu.label}</span>
      </a>
    );
  }
}


@observer
class MenuItem extends React.Component {
  constructor (props) {
    super(props);
  }

  handleClick = (e) => {
    const { menuId, href, history, isActive } = this.props;

    if (href) {
      utils.handleGoTo(e, history, href);
      return;
    }

    // toggle display
    e.preventDefault();

    if (isActive) {
      this.props.updateActiveMenu("");
      return;
    }

    this.props.updateActiveMenu(menuId);
  };

  render() {
    const { href, menuName, icon, isActive, activeSidebar, subMenus } = this.props;

    return (
      <div className="menu-item">
        <a
          className={isActive && subMenus.length === 0 ? "primary-link active-link" : "primary-link"}
          onClick={this.handleClick}
          href={href || "#"}
        >
          <Icon.Box icon={icon} />
          <span className="primary-label">{menuName}</span>
        </a>

        {isActive && subMenus.length > 0 ? (
          <div className="submenu-items">
            {subMenus.map((subMenu) =>
              <SubMenuItem
                key={uniqueId()}
                subMenu={subMenu}
              />
            )}
          </div>
        ): null}
      </div>
    );
  }
}



export default MenuItem;
